import template from "./address.html";
import {addressController} from "./address.controller";

export const addressComponent = {
	template,
	controller: addressController,
	controllerAs: "address",
	bindings: {
		model: "=",
		location: "@"
	}
};



// WEBPACK FOOTER //
// ./sources/components/common/address/address.component.js